import { useStore } from 'effector-react';
import { Typography } from '@mui/material';
import { ChatInput } from '@features/socket-chats-reworked/components/chat/chat-input';
import { $isReadonly, $isSelectMode } from '@features/socket-chats-reworked/models';
import i18n from '@shared/config/i18n';
import { ChatSelectPanel } from '../chat-select-panel';
import { ChatTabsTypes } from '../../../types/chat-tabs';
import { useStyles } from './styles';

const { t } = i18n;

export const ChatFooter = ({
  activeChatTab,
  canWriteInTicketResidentChat,
}: {
  activeChatTab: ChatTabsTypes;
  canWriteInTicketResidentChat?: boolean;
}) => {
  const isSelectMode = useStore($isSelectMode);
  const isReadonly = useStore($isReadonly);
  const classes = useStyles();

  const renderContent = () => {
    if (isReadonly)
      return (
        <div className={classes.chatFooter__readonly}>{t('YouOnlyHaveViewMode')}</div>
      );
    if (isSelectMode) return <ChatSelectPanel />;

    if (activeChatTab === 'employees' && !canWriteInTicketResidentChat)
      return (
        <Typography variant="body2" className={classes.chatFooter__cant_communicate}>
          {t('CantCommunicateWithTheApplicantViaChat')}
        </Typography>
      );

    return <ChatInput />;
  };

  return <div className={classes.chatFooter}>{renderContent()}</div>;
};
